import type { PropsWithChildren } from 'react'
import React from 'react'
import { useLocation } from 'react-router'

import type { AppStateReducerAction } from './reducer'
import appStateReducer from './reducer'
import type IAppState from './state'
import { initialAppState } from './state'

export type AppStateContextType = [IAppState, React.Dispatch<AppStateReducerAction>]
export const AppStateContext = React.createContext<AppStateContextType>([
  initialAppState,
  () => undefined,
])

const AppStateProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const location = useLocation()
  const stateAndDispatch = React.useReducer(appStateReducer, initialAppState)
  const [state, dispatch] = stateAndDispatch

  React.useEffect(() => {
    if (!!state.error) {
      dispatch({
        payload: {
          error: undefined,
        },
        type: 'displayError',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return <AppStateContext.Provider value={stateAndDispatch}>{children}</AppStateContext.Provider>
}

export default AppStateProvider
